<template>
  <div style="width: 100%;">
    <img
      src="http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_banner_sec.jpg"
      style="width: 100vw;height: 20vw;margin-top:2px;"
    />

    <div v-if="ISphone" class="fx-column fx-row-center">
      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_infor_2_ph.png"
        style="width: 100vw;"
      />

      <!-- _2_ph -->
      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_type.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_advance_2_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_case_2_ph.png"
        style="width: 100vw;"
      />
    </div>
    <div v-else>
      <div class="fx-column fx-row-center" style="width: 100vw; background: white;">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">什么是信息流推广</div>

        <div class="blueline"></div>

        <div
          :class="ISphone ? smallh2label : bigh3label"
          style="width: 56vw; margin-top: 3vw; margin-bottom:4vw;color:#515978; "
        >愉悦推通过机器学习算法为用户精准推荐内容，让信息流广告以原生方式出现在资讯信息流中，根据用户属性、历史浏览行为和兴趣爱好进行精准定向投放</div>
      </div>

      <!--      方案-->
      <div class="plan fx-column fx-row-center">
        <div
          :class="ISphone ? smallh2label : bigh2label"
          style="margin-top: 3vw; margin-bottom: 4vw; width:90%;"
        >丰富的广告展示样式，通过多样化展示，提高广告的点击率</div>

        <!-- <div class="blueline"></div> -->

        <div class="plantable fx-row fx-row-center fx-row-space-between">
          <div
            class="plancell hvr_grow_shadow fx-column fx-row-center"
            v-for="(item, index) in planarray"
            v-bind:key="index"
          >
            <img class="plancell_icon" :src="item.iconurl" />
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              class="plancell_name"
              style="color:#16214B;"
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh3label : 'pxlabel_14'"
              class="plancell_des"
              style="color:#515978;"
            >{{ item.desstr }}</div>
          </div>
        </div>
      </div>

      <!--   业务  bussiness -->
      <div class="bussiness fx-column fx-row-center" style="background:white;">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">我们的优势</div>
        <div class="blueline"></div>

        <div
          class="fx-row fx-row-top fx-row-space-between"
          style="width: 75vw; margin-top: 4vw; margin-bottom: 4vw;"
        >
          <div
            class="fx-column fx-row-center"
            v-for="(item, index) in bussinessdataArray"
            v-bind:key="index"
          >
            <img class="bussiness_icon hvr_grow_shadow" :src="item.iconurl" />
            <div
              :class="ISphone ? smallh2label : 'pxlabel_28'"
              class="bussiness_title"
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh2label : 'pxlabel_14'"
              class="bussiness_des"
            >{{ item.desstr }}</div>
          </div>
        </div>

        <!--      21vw   24.6vw   -->
      </div>

      <img
        src="http://pic.midongtech.xyz/yytgw/assets/Deliverycases.jpg"
        style="width: 100vw;height: 48vw;margin-top:2px;"
      />
    </div>

    <contactusview />
  </div>
</template>
<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";

export default {
  name: "InformationPromotion",
  components: {
    contactusview
    // companybtm,
    //   partner
  },

  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",
      numbersarray: [
        {
          count: "1W+",
          des: "服务广告主数量"
        },
        {
          count: "6亿",
          des: "覆盖智能设备数"
        },
        {
          count: "10W",
          des: "覆盖APP数量"
        }
      ],

      planarray: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_ad_fir.png",
          titlestr: "单图文广告",
          desstr: "重点展现文案，以精准的语言吸引用户注意"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_ad_sec.png",
          titlestr: "三小图广告",
          desstr: "多帧画面，展示内容概要，体现故事性，引起用户兴趣"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_ad_thir.png",
          titlestr: "通栏大图广告",
          desstr: "以震撼大图抢夺用户注意力，从信息流中脱颖而出"
        }
      ],
      bussinessdataArray: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_advantage_fir.png",
          titlestr: "用户分布广泛",
          desstr:
            "千万级装机用户，以广东、上海、北京、浙江、山东、四川、河南、福建、湖北、江苏等重点省份的核心城市为据点，辐射周边城市，覆盖消费升级人群"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_advantage_sec.png",
          titlestr: "投资回报率高",
          desstr:
            "配合基于机器学习的推荐引擎和实时海量数据处理技术，让资讯内容和广告信息准确推送至转化率、留存率高的优质用户。实现广告投放的最小投入，最优效果"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_advantage_thir.png",
          titlestr: "更专业的服务",
          desstr:
            "通过多样化的广告形式，为不同需求的品牌主量身定制一体化的推广方案。接入操作简单便捷，7*24小时贴心顾问式服务，随时随地进行效果监控"
        }
      ]
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
  },
  methods: {
    /**
     * 点击事件
     */
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped>
/*页面公共样式*/

.redbigtitle {
  font-family: PingFang-SC-Semibold;
  // font-size: 2.5vw;
  color: #ff496a;
  /*letter-spacing: 0.71px;*/
  // width: 7.8vw;
  // height: 6vw;
  line-height: 6vw;
  font-weight: bold;
}

.usercelldes {
  width: 8vw;
  // height: 1.5vw;
  /*font-family: PingFang-SC-Regular;*/
  // font-size: 0.5vw;
  color: #16214b;
  letter-spacing: 0.17px;
}

.plan {
  background: #f3f4f6;
  width: 100vw;
}
.plantitle {
  width: 28vw;
  // height: 1.5vw;
  // font-size: 1vw;
  margin-top: 4.2vw;
  text-align: center;
  margin-bottom: 4vw;
}

.plantable {
  width: 80vw;
  margin-bottom: 4vw;
}
.plancell {
  width: 24vw;
  // height: 30vw;
  background: #ffffff;
  box-shadow: 0 21px 43px 0 rgba(22, 33, 75, 0.15);
  border-radius: 4px;
  padding-top: 1vw;
  padding-bottom: 1vw;
}
.plancell_icon {
  width: 17vw;
  height: 17vw;
  margin-top: 3vw;
}
.plancell_name {
  // width: 9vw;
  // font-size: 1.5vw;
  margin-top: 1vw;
  text-align: center;
  font-weight: middle;
  color: #16214b;
}

.plancell_des {
  margin-top: 1vw;
  margin-bottom: 4vw;
  // font-size: 0.9vw;
  width: 18.2vw;
  text-align: center;
  color: #515978;
}
</style>
